var map = {
	"./amica.json": "4838",
	"./astanet.json": "455b",
	"./baltycka.json": "012a",
	"./base.json": "fbf8",
	"./bialy-kamien.json": "d83e",
	"./centrum-riviera.json": "0ad6",
	"./cpr-demo.json": "aa77",
	"./demo-knowledge.json": "a29b",
	"./develop.json": "c0bd",
	"./goodfood.json": "42a1",
	"./lira.json": "d04c",
	"./pasaz-grunwaldzki.json": "9ab3",
	"./pomorska.json": "9e8d",
	"./posnania.json": "a9d7",
	"./schema.json": "2695",
	"./valo-motion.json": "84c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9285";